import { Component, OnInit } from '@angular/core';
import { GlobalserviceService } from '../globalservice.service';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { google } from '@agm/core/services/google-maps-types';
import { MapsAPILoader } from '@agm/core';
//import { InfoWindowManager } from '@agm/core/services/managers/info-window-manager';


@Component({
  selector: 'app-view-map',
  templateUrl: './view-map.component.html',
  styleUrls: ['./view-map.component.css']
})
export class ViewMapComponent implements OnInit {
  method: any;
  currentdate: any;
  name?: string; lat: number; lng: number; data123; currentlat; currentlng; public obj = [];
  currentindex: number; stat; mapdatas = {}; datas;
  ODusers = []; public isClicked = []; buttonColor; emp;
  ODuserprgm: any;prgm;
  public allprgm;
  oduser= [];
  od= [];data=[];
  pd;resp;datasmeth;
  arry: any;
  selectedRow: any;
  filterlocation: string;
  Department: string;
  IW: any;
  previous: any;
  zoom: number;
  p: any;
  show;

  status: boolean = false;

  constructor(  private mapsAPILoader: MapsAPILoader, public globalservice: GlobalserviceService, private router: Router,public snackBar: MatSnackBar) {}


  previous_info_window = null;
  ODuser = [];
  infoWindowOpened = null;
  mapdata = [];
  s1 = [];
  ngOnInit() {
    this.previous_info_window = null;
    this.OD_details(Object);
     this.currentindex = 0;
     this.selectedRow='1';
     this.select(Object);
     debugger;
     this.show = true;
  }

  //

clickEvent(i){
  this.show = false;
 // console.log(i); debugger;
  // if(i==0){
  //   this.status = true;
  //   this.show = true;
  // }
   // this.status = !this.status;
}

  //


  backward() {
    this.router.navigate(['/dashboard/ODuser_Table']);
    var firstlat = sessionStorage.firstlat;
    delete sessionStorage.firstlat;
    var firstlong = sessionStorage.firstlong;
    delete sessionStorage.firstlong;
  }
 OD_details(i) {
  var data = {
    "EMP_ID": sessionStorage.getID
  }
  this.emp=sessionStorage.getID;
   this.globalservice.enableloader();
  this.globalservice.OD_Details(data).subscribe(responsedata => {
    this.globalservice.disableloader();
    if (responsedata.Success) {
      this.ODuser = responsedata['Data'];
console.log(this.ODuser); debugger;
      for (var i = 0; i < this.ODuser.length; i++) {
        this.allprgm=this.ODuser[i].ProgramDetails;
        this.data.push( this.allprgm)
      }
      this.pd=this.data
      for (var i = 0; i < this.ODuser[0].ProgramDetails.length; i++) {
       this.obj.push({
              "currentlat": parseFloat(this.ODuser[0].ProgramDetails[i].Start_Program_Location_Lat),
              "currentlng": parseFloat(this.ODuser[0].ProgramDetails[i].Start_Program_Location_Long),
               "OD_start": this.ODuser[0].OD_Start_Time,
               "OD_startloct": this.ODuser[0].OD_Start_Location_Name,
               "start_prgmName":this.ODuser[0].ProgramDetails[i].Start_Program_Location_Name,
               "start_timeprgm":this.ODuser[0].ProgramDetails[i].Start_Program_Time,
               "customer":this.ODuser[0].ProgramDetails[i].Customer,
               "reason":this.ODuser[0].ProgramDetails[i].Purpose_Description,
               "endprgmName":this.ODuser[0].ProgramDetails[i].End_Program_Location_Name,
               "endprgmTime":this.ODuser[0].ProgramDetails[i].End_Program_Time,
               "OD_endName":this.ODuser[0].OD_End_Location_Name,
               "OD_endTime":this.ODuser[0].OD_End_Time,
               "prgmTime":this.ODuser[0].ProgramDetails[i].Program_Duration,
               "visiable":false
        });
      }
     sessionStorage.setItem("firstlat",this.obj[0].currentlat);
      sessionStorage.setItem("firstlong",this.obj[0].currentlng);
      this.lat =parseFloat(sessionStorage.firstlat);
     this.lng =parseFloat(sessionStorage.firstlong);
      this.zoom=9;
    }
    else {
      this.router.navigate(['/dashboard/ODuser_Table']);
      this.snackBar.open('There is No OD for the User', '', { duration: 3000 });
      this.stat = true;
    }

  },
    err => {
      alert("Network Error");
    });
}
select(i){
  this.selectedRow = i;
}

        //
next(i,data123) {
  this.selectedRow = i;
  this.globalservice.enableloader();
  this.ODuser = data123;
  this.buttonColor = '#345465';
  this.zoom =11;
  this.lat=parseFloat(this.ODuser[i].ProgramDetails[0].Start_Program_Location_Lat),
  this.lng=parseFloat(this.ODuser[i].ProgramDetails[0].Start_Program_Location_Long),
  this.obj=[];
  this.globalservice.disableloader();
  for (var j = 0; j < this.ODuser[i].ProgramDetails.length; j++) {
    this.obj.push({
           "currentlat": parseFloat(this.ODuser[i].ProgramDetails[j].Start_Program_Location_Lat),
           "currentlng": parseFloat(this.ODuser[i].ProgramDetails[j].Start_Program_Location_Long),
           "OD_start": this.ODuser[i].OD_Start_Time,
           "OD_startloct": this.ODuser[i].OD_Start_Location_Name,
           "start_prgmName":this.ODuser[i].ProgramDetails[j].Start_Program_Location_Name,
           "start_timeprgm":this.ODuser[i].ProgramDetails[j].Start_Program_Time,
           "customer":this.ODuser[i].ProgramDetails[j].Customer,
           "reason":this.ODuser[i].ProgramDetails[j].Purpose_Description,
           "endprgmName":this.ODuser[i].ProgramDetails[j].End_Program_Location_Name,
           "endprgmTime":this.ODuser[i].ProgramDetails[j].End_Program_Time,
           "OD_endName":this.ODuser[i].OD_End_Location_Name,
           "OD_endTime":this.ODuser[i].OD_End_Time,
           "prgmTime":this.ODuser[i].ProgramDetails[j].Program_Duration,
           "visiable":false
    });
  }

  this.previous_info_window = null;

}




clickedMarker(infoWindow){

  console.log(infoWindow);
  if (this.previous_info_window == null) {
    this.previous_info_window = infoWindow;
    this.previous_info_window.close();
  }
  else{
    this.infoWindowOpened = infoWindow;
    this.previous_info_window.close();
    this.previous_info_window = infoWindow;
  }
 }
}
